import { Box, Center, Flex, SimpleGrid } from "@chakra-ui/react";
import { NextPage } from "next";
import Link from "next/link";

import { Column, Heading, Index } from "./styles";

export const IndexView: NextPage = ({ data }) => {
  const isOccasionsPage = (data.article.slug as string) === "occasions";

  // Allow for space at start of attribute name, but don't show any that start with a special char
  const items = data.other[0].values.map((x) => [x.name.trim(), x.slug]);
  items.sort();
  const entries = new Set();

  // Put numbers after letters
  const alphabeticItems = items.filter((x) => /[a-zA-Z]+.*/.test(x[0]));
  const numericItems = items.filter((x) => /\d+.*/.test(x[0]));
  [...alphabeticItems, ...numericItems].forEach((x) =>
    entries.add(x[0].slice(0, 1))
  );

  // for the link, if its designer go to /designer/, otherwise all go to /page/
  const linktype =
    data.article.metadata.find((x) => x.key === "attribute").value ===
    "designer"
      ? "designers"
      : "page";

  const boxes = [...entries].map((x) => (
    <Box maxW="xs" key={x}>
      <a id={x} name={x}>
        <br />
        <br />
        <Heading>{x}</Heading>
        <SimpleGrid columns={2}>
          {items
            .filter((y) => y[0].slice(0, 1) === x)
            .map((y) => (
              <Column>
                <Link
                  prefetch={false}
                  href={
                    isOccasionsPage
                      ? `/occasions/${y[1]}`
                      : `/${linktype}/${y[1]}`
                  }
                >
                  {y[0]}
                </Link>
              </Column>
            ))}
        </SimpleGrid>
      </a>
    </Box>
  ));

  const indexes = [...entries].map((x) => (
    <Box key={x}>
      <Index href={`#${x}`}>{x}</Index>
    </Box>
  ));

  return (
    <Box padding="20px">
      <Flex direction="column">
        <Center>
          <h1>{data.article.title}</h1>
        </Center>
        <br />
        <span>{JSON.parse(data.article.content)?.blocks?.[0]?.data?.text}</span>
      </Flex>
      <br />
      <SimpleGrid minChildWidth="30px" spacing="5px">
        {indexes}
      </SimpleGrid>
      <br />
      <SimpleGrid minChildWidth="400px" spacing="20px">
        {boxes}
      </SimpleGrid>
    </Box>
  );
};
